const endpoints = {
  createRemunerationsFixed: (): string => `remuneration/fixed`,
  showRemunerationFixed: (id: string): string => `remuneration/fixed/${id}`,
  inactivateRemunerationFixed: (id: string): string =>
    `remuneration/fixed/inactivate/${id}`,
};

export default endpoints;
